import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Button from "@material-ui/core/Button";
import { showNotification, CREATE, GET_ONE } from "react-admin";
import { push } from "react-router-redux";
import dataProviderFactory from "../dataProvider";
import styled from "styled-components";
import { BF_ROOT, B2_ROOT } from "../api-config";

const StyledButton = styled(Button)`
  color: black !important;
`;

class GenerateMagicLink extends Component {
  handleClick = async () => {
    try {
      const dataProvider = await dataProviderFactory("rest");
      const { record, showNotification } = this.props;
      
      // Determinar si es una agencia y obtener el ID del usuario
      const isAgency = record.agency_status === 1;
      const userId = isAgency ? record.user_id : record.user.id;
      
      let clientId;
      let clientData;
      
      if (isAgency) {
        // Para agencias, obtener primero el cliente por user_id
        const userResult = await dataProvider(GET_ONE, "clients/user_id", { id: userId });
        clientData = userResult.data;
        clientId = clientData.id;
      } else {
        // Para clientes normales, usar el record directamente
        clientData = { ...record, is_approved: true };
        clientId = record.id;
      }
      
      // Generar el magic link
      await dataProvider(CREATE, `users/generate_magic_link/${clientId}`, {
        id: clientId,
        data: clientData
      });
      
      // Obtener el cliente actualizado con el temp_uid
      const clientResult = await dataProvider(GET_ONE, "clients", { id: clientId });
      
      // Abrir la nueva ventana con el magic link
      window.open(`${BF_ROOT}/?with_uid=${clientResult.data.temp_uid}`);
      
    } catch (error) {
      console.error("Error generating magic link:", error);
      this.props.showNotification("Error: No se pudo procesar la solicitud", "warning");
    }
  };

  render() {
    return (
      <StyledButton onClick={this.handleClick} target="_blank">
        Login
      </StyledButton>
    );
  }
}

GenerateMagicLink.propTypes = {
  push: PropTypes.func,
  record: PropTypes.object,
  showNotification: PropTypes.func
};

export default connect(null, {
  showNotification,
  push
})(GenerateMagicLink);



// WEBPACK FOOTER //
// ./src/components/generateMagicLink.js